export default __webpack_public_path__ + "static/lars-kienle-IlxX7xnbRF8-unsplash-3bd00438f445b5fda2f03d1aa5f4e53f.jpg";